import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import productMenuItems from './productMenuItems';
import { whatsappCrmConfig } from './servicePageConfigs';

const productWhatsappCrmConfig = {
  ...whatsappCrmConfig,
  seo: {
    ...whatsappCrmConfig.seo,
    title: 'WhatsApp CRM For Marketplace Leads & API Automation | SwiftMaze',
    description:
      'WhatsApp CRM for IndiaMART and TradeIndia lead automation, WhatsApp follow-ups, developer APIs, webhooks, campaigns, sales, and customer support teams.',
    canonical: 'https://www.swiftmazetech.com/products/whatsapp-crm/',
    schemaName: 'SwiftMaze WhatsApp CRM Software',
    schemaType: 'WhatsApp CRM Product',
  },
  servicePath: '/products/whatsapp-crm',
  relatedItems: productMenuItems,
  relatedTitle: 'Related Products',
  relatedText:
    'Explore SwiftMaze products built for communication, education operations, medical business workflows, and daily team productivity.',
};

const ProductWhatsappCrm = () => (
  <ServicePageTemplate {...productWhatsappCrmConfig} />
);

export default ProductWhatsappCrm;
